import { ProductTypeCard } from './ProductTypeCard';
import { DisplayProduct } from '../product-type.types';

interface ProductTypeGridProps {
  products: DisplayProduct[];
}

export function ProductTypeGrid({ products }: ProductTypeGridProps) {
  if (!products || products.length === 0) return null;

  return (
    <div className="grid md:gap-5 gap-sm grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {products.map((product, index) => (
        <ProductTypeCard key={product?._id ?? `product-${index}`} product={product} index={index} />
      ))}
    </div>
  );
}
